import {WheelOfJackpotbetDialogMrGreenBox} from "./wheel-of-jackpotbet-dialog.mrgreen.box";

export const WheelOfJackpotbetDialogMrgreenCisBox = WheelOfJackpotbetDialogMrGreenBox;